import { UserRecords } from '@/models/record'
import { AppUtil } from 'kuaidong-lib'

export default class ARecord {
  public static async getByClazzStudent(
    clazzId: number,
    userId: string,
    startTime: Date,
    endTime: Date
  ): Promise<UserRecords> {
    return AppUtil.httpGET('/clazz/student/record', {
      clazz_id: clazzId,
      user_id: userId,
      start_time: startTime,
      end_time: endTime,
    })
  }

  public static async removeFromRangeList(recordId: string) {
    return AppUtil.httpDelete('/drill/rank/off_board', { record_id: recordId })
  }
}
